import React, { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";

export default function Hero() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => setProgress(Math.min(window.scrollY / Math.max(window.innerHeight, 1), 1));
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const textOpacity = Math.max(0, 1 - progress * 1.4);

  return (
    <section className="relative h-screen w-full overflow-hidden flex items-center justify-center" data-testid="hero">
      <div
        className="relative z-10 text-center px-6 max-w-4xl pt-28 md:pt-0"
        style={{ opacity: textOpacity, transform: `translateY(${progress * -60}px)` }}
      >
        <p className="text-white/80 tracking-[0.35em] text-[10px] sm:text-xs md:text-sm uppercase mb-5">
          Financement et investissement
        </p>
        <div className="gold-sep mx-auto mb-6 md:mb-8" />
        <h1 className="font-serif-display text-3xl sm:text-4xl md:text-6xl lg:text-7xl text-white leading-tight">
          Solution cl&eacute; en main pour le financement
          <br className="hidden md:block" /> et l'achat immobilier au{" "}
          <span className="text-[#2f74c9] italic">Mexique</span>
        </h1>
        <p className="text-white/85 text-sm sm:text-base md:text-lg mt-6 md:mt-8 max-w-2xl mx-auto font-light">
          Peu importe le projet de vos r&ecirc;ves, nous avons les outils et la solution.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mt-8 md:mt-10">
          <Link to="/proprietes" className="btn-gold px-8 py-4 rounded-sm font-600 tracking-wide">
            Voir les propri&eacute;t&eacute;s
          </Link>
          <Link
            to="/contact"
            className="px-8 py-4 rounded-sm font-600 tracking-wide border border-white/60 text-white hover:bg-white hover:text-[#0b1f33] transition-colors"
          >
            Parler &agrave; un conseiller
          </Link>
        </div>
      </div>

      <div
        className="absolute bottom-8 md:bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2"
        style={{ opacity: textOpacity }}
      >
        <span className="text-white/60 text-[10px] tracking-[0.3em] uppercase">Faites d&eacute;filer pour voyager</span>
        <div className="w-6 h-10 rounded-full border border-white/50 flex items-start justify-center pt-2">
          <span className="scroll-dot w-1 h-2 rounded-full bg-[#2f74c9]" />
        </div>
        <ChevronDown size={16} className="text-white/40" />
      </div>
    </section>
  );
}
